import {ADD_CHECKED_TASK} from "../reducers/tasksCheckedReducer";

export const addCheckedTask = (data) => {
  return {type: ADD_CHECKED_TASK, payload: data}
}

